import React from 'react'

import { UnknownObject } from 'src/utils/reactTypes'

export const AwardIcon: React.FC<UnknownObject> = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9997 13.7498C14.5435 13.7498 17.4163 10.877 17.4163 7.33317C17.4163 3.78934 14.5435 0.916504 10.9997 0.916504C7.45585 0.916504 4.58301 3.78934 4.58301 7.33317C4.58301 10.877 7.45585 13.7498 10.9997 13.7498Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.52616 12.7323L6.41699 21.0831L11.0003 18.3331L15.5837 21.0831L14.4745 12.7231"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
